var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.libraryAssociationResponse && _vm.isActive)?_c('div',[_c('PreAssociation')],1):_vm._e(),(_vm.libraryAssociationResponse)?_c('div',[_c('PostAssociation',{on:{"next":function($event){return _vm.$emit('next')}}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }